import type { PigeonClient } from './index';
import type { DeclarationPage } from '../../types';

/**
 * Ask pigeon to parse a manual upload's dec pages — moved verbatim from Parrot's
 * UploadView. Best effort: the dec pages already exist in Owl, so this never
 * throws and never blocks the caller more than 5s waiting for the ack.
 */
export async function triggerManualParseForSubmission(
  pigeon: Pick<PigeonClient, 'connectToSocket' | 'triggerManualParse'>,
  args: {
    clientId: string;
    submissionId: string;
    carrierSlug: string;
    declarationPages: Pick<
      DeclarationPage,
      'uuid' | 'publicUrl' | 'policyId'
    >[];
  },
): Promise<void> {
  if (!args.declarationPages.length) return;

  const pages = args.declarationPages.map((dp) => ({
    decPageUuid: dp.uuid,
    fileUrl: dp.publicUrl,
    fileType: (() => {
      try {
        const ext = new URL(dp.publicUrl).pathname.split('.').pop();
        return ext && ext.length <= 5 ? ext.toLowerCase() : 'pdf';
      } catch {
        return 'pdf';
      }
    })(),
    alreadyLinked: Boolean(dp.policyId),
  }));

  try {
    await pigeon.connectToSocket();
    await Promise.race([
      pigeon.triggerManualParse({
        clientId: args.clientId,
        submissionId: args.submissionId,
        carrierSlug: args.carrierSlug,
        pages,
      }),
      new Promise((resolve) => setTimeout(resolve, 5000)),
    ]);
  } catch (err) {
    console.error(
      '[triggerManualParseForSubmission] Failed to trigger manual parse:',
      err,
    );
  }
}
